import { getScrollStyles } from './scrollbar.styles';

export const splitScreenStyle = {
  display: 'flex',
  width: '100%',
  height: '100%',
};

export const getSplitScreenStyles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    '& .gutter': {
      width: '8px',
      background: theme.palette.divider,
      cursor: 'col-resize',
    },
  },
  treeBlock: {
    ...getScrollStyles(theme).scroll,
    overflowY: 'auto',
    padding: '5px',
  },
  contentBlock: {
    ...getScrollStyles(theme).scroll,
    overflowY: 'auto',
  },
});
